import { Component, input } from '@angular/core';
import type { GlossaryEntry } from '../../interfaces/glossaryInterface';
import { GlossaryTagComponent } from '../glossary-tag/glossary-tag.component';

@Component({
    selector: 'app-glossary-entry',
    imports: [GlossaryTagComponent],
    templateUrl: './glossary-entry.component.html',
    styleUrl: './glossary-entry.component.scss'
})
export class GlossaryEntryComponent {
  entry = input.required<GlossaryEntry>();
}
